
function Error404() {
    return (
        <main>
            <h1>404: PAGE NOT FOUND</h1>
            <p>Oops, sorry, we can't find this page!</p>
            <img src="http://localhost:5000/images/kittykat.jpeg" alt="cute cat pic" />
        </main>
    );
}

export default Error404;
